import styled from 'styled-components';

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const LogoIcon = styled.img<{ $size: string }>`
  width: ${props => props.$size};
  height: ${props => props.$size};
  object-fit: cover;
  border-radius: 9px;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.22));
`;

export const LogoText = styled.span<{ $color: string }>`
  font-family: 'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1;
  text-transform: uppercase;
  color: ${props => {
    switch (props.$color) {
      case 'white':
        return '#FFFFFF';
      case 'dark':
        return '#1A4D3A';
      case 'green':
      default:
        return '#1A4D3A';
    }
  }};
  text-shadow: ${props => props.$color === 'white' ? '0 2px 8px rgba(0, 0, 0, 0.35), 0 0 14px rgba(255, 255, 255, 0.22)' : 'none'};
  white-space: nowrap;
`;
